import Popover from "@components/popovers/Popover";
import PopoverItem from "@components/popovers/PopoverItem";
import useOpener from "@hooks/useOpener";

type Props = {
  handleDestroy?: () => void;
  handleEdit: () => void;
  handleUpload?: () => void;
};

const TrackerPopover = ({ handleDestroy, handleEdit, handleUpload }: Props) => {
  const opener = useOpener();

  return (
    <div>
      <Popover color="primary" isOpen={opener.isOpen} opener={opener}>
        <PopoverItem
          icon="gear"
          noBorder={!handleDestroy}
          onClick={() => {
            handleEdit();
            opener.close();
          }}
          textKey="dictionary.edit"
        />
        {handleDestroy && (
          <PopoverItem
            icon="trash"
            noBorder
            onClick={() => {
              handleDestroy();
              opener.close();
            }}
            textKey="pages.drive.delete"
          />
        )}
        {handleUpload && (
          <PopoverItem
            icon="upload"
            noBorder
            onClick={() => {
              handleUpload();
              opener.close();
            }}
            textKey="pages.drive.uploadDocument"
          />
        )}
      </Popover>
    </div>
  );
};

export default TrackerPopover;
